import React from 'react';
export default class AnimationComponent extends React.Component {
    constructor() {
        super();
        this.makeAnimation = this.makeAnimation.bind(this);
    }
    componentDidMount() {
        this.makeAnimation()

    }

    makeAnimation() {
        var ref = this;
        if (window.bodymovin) {
            var animation = window.bodymovin.loadAnimation({
                container: this.animation,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: this.props.animationPath
            })
        } else {
            setTimeout(function () {
                ref.makeAnimation();
            }, 200)
        }

    }
    render() {
        return (<div className={this.props.styleClass}
            ref={(animation) => { this.animation = animation }}>
        </div>);
    }
}